/**
 *  权限指令，如果用户没有对应按钮的资源key，则隐藏
 *  例子  : <div v-ab-btn-rights:btnResourceCode ></div>
 */
export default {
  inserted(el,binding,vnode){
	var code = binding.arg || binding.value;
    if(!code) return;
    try{
		 let btnPermission = vnode.context.$store.state.admin.user.info.buttonPermision;
	    if(btnPermission && btnPermission[code]){
			return;
		}
    }catch(e){ }
	
	console.info(code +" no rights");
	el.hidden = true;
	el.style.display = 'none'
  }
}
